import { IAddUpdateRepasseSetorialRequest } from "../../../../model/admin-portal/request/add-update-repasse-setorial-request";
import { IRepasseSetorialResponse } from "../../../../model/admin-portal/response/repasse-setorial-response";
import { IAreaTransparenciaSetorialResponse } from "../../../../model/admin-portal/response/area-transparencia-setorial-response";
import { IOrigemRepasseSetorialResponse } from "../../../../model/admin-portal/response/origem-repasse-setorial-response";
import { ITermPaggedRequest } from "../../../../model/admin-portal/request/term-pagged-request";
import { PaginationResponse } from "../../../../model/base/response/pagination-response";

export type RepassesSetoriaisState = {
    dataPaginatedListResponse: PaginationResponse<IRepasseSetorialResponse>;
    isLoadingData: boolean;
    dataResponse: IRepasseSetorialResponse | null;
    dataRequest: IAddUpdateRepasseSetorialRequest;
    showAddEdit: boolean;
    dataSearchRequest: ITermPaggedRequest;
    areasList: IAreaTransparenciaSetorialResponse[];
    origensList: IOrigemRepasseSetorialResponse[];
};

export const initialDataRequest: IAddUpdateRepasseSetorialRequest = {
    id: null,
    idAreaTransparenciaSetorial: null,
    idOrigemRepasseSetorial: null,
    ano: null,
    textoDescricao: '',
    valorPrevisto: null,
    valorRealizado: null,
    dtaPublicacao: ''
};

export const initialState: RepassesSetoriaisState = {
    dataPaginatedListResponse: new PaginationResponse<IRepasseSetorialResponse>(),
    isLoadingData: false,
    dataResponse: null,
    dataRequest: initialDataRequest,
    showAddEdit: false,
    dataSearchRequest: { page: 0, pageSize: 10, term: '' },
    areasList: [],
    origensList: []
};

export enum ACTION_TYPES {
    setDataPaginatedListResponse = 'setDataPaginatedListResponse',
    setIsLoadingData = 'setIsLoadingData',
    setDataResponse = 'setDataResponse',
    setDataRequest = 'setDataRequest',
    setShowAddEdit = 'setShowAddEdit',
    setDataSearchRequest = 'setDataSearchRequest',
    setAreasList = 'setAreasList',
    setOrigensList = 'setOrigensList'
}

type Action =
    | { type: ACTION_TYPES.setDataPaginatedListResponse; payload: PaginationResponse<IRepasseSetorialResponse> }
    | { type: ACTION_TYPES.setIsLoadingData; payload: boolean }
    | { type: ACTION_TYPES.setDataResponse; payload: IRepasseSetorialResponse | null }
    | { type: ACTION_TYPES.setDataRequest; payload: IAddUpdateRepasseSetorialRequest }
    | { type: ACTION_TYPES.setShowAddEdit; payload: boolean }
    | { type: ACTION_TYPES.setDataSearchRequest; payload: ITermPaggedRequest }
    | { type: ACTION_TYPES.setAreasList; payload: IAreaTransparenciaSetorialResponse[] }
    | { type: ACTION_TYPES.setOrigensList; payload: IOrigemRepasseSetorialResponse[] };

export const repassesSetoriaisReducer = (state: RepassesSetoriaisState, action: Action): RepassesSetoriaisState => {
    switch (action.type) {
        case ACTION_TYPES.setDataPaginatedListResponse:
            return { ...state, dataPaginatedListResponse: action.payload };
        case ACTION_TYPES.setIsLoadingData:
            return { ...state, isLoadingData: action.payload };
        case ACTION_TYPES.setDataResponse:
            return { ...state, dataResponse: action.payload };
        case ACTION_TYPES.setDataRequest:
            return { ...state, dataRequest: action.payload };
        case ACTION_TYPES.setShowAddEdit:
            return { ...state, showAddEdit: action.payload };
        case ACTION_TYPES.setDataSearchRequest:
            return { ...state, dataSearchRequest: action.payload };
        case ACTION_TYPES.setAreasList:
            return { ...state, areasList: action.payload };
        case ACTION_TYPES.setOrigensList:
            return { ...state, origensList: action.payload };
        default:
            return state;
    }
};
